import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import _ from 'lodash';
import {
  Grid,
  Button,
  ButtonToolbar,
  Clearfix,
  Glyphicon,
  Nav,
  NavItem,
} from 'react-bootstrap';

import linkWithCredentials from '../../../utils/linkWithCredentials';
import { queryAllJobTicketsGQL } from '../graphql/jobTicketsApi';
import DetailsProcessorEnhanced from './DetailsProcessorEnhanced';

import {
  setTicketId,
  dispatchUpdateJob,
} from '../actions';

import { getApiServerUrl } from '../../configuration/selectors';
import { getUserFeatures } from '../../authentication/selectors';
import JobEditorModal, { withModalState, jobEditorModalPropTypes } from '../../forms/jobEditor/components/JobEditorModal';

import { tryHandleGraphQLError } from '../../../utils/graphQLErrorHandlers';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

/* FIXME: Currently, unreachable code. Remove when wired in */
/* eslint-disable */
const propTypes = exact({
  ticketId: PropTypes.number,
  jobId: PropTypes.number.isRequired,
  setTicketIdAction: PropTypes.func.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
  allJobTickets: PropTypes.array,
  currentJob: PropTypes.object,
  features: PropTypes.object.isRequired,
  dispatchUpdateJobAction: PropTypes.func.isRequired,
  ...jobEditorModalPropTypes,
});
/* eslint-enable */


const JobViewer = (props) => {
  const {
    jobId,
    ticketId,
    allJobTickets,
    currentJob,
    features,
    showJobEditorModal,
    openJobEditorModal,
    closeJobEditorModal,
    jobEditorErrors,
    dispatchUpdateJobAction,
    setJobEditorModalError,
  } = props;

  const {
    update_immutable_tickets: updateImmutableTickets,
    destroy_tickets: destroyTickets,
    replace_completed_tickets: replaceCompletedTickets,
    viewer,
  } = features;

  const handleSelectedTicket = () => {
    /* NOTE: if ticketId is in the list of allJobTickets, use it
    * else use the first in the list */
    const resultIndex = _.findIndex(allJobTickets, (jobTicket) => {
      return jobTicket.id === ticketId;
    });

    const resultSelectedTicketId = (resultIndex < 0) ? allJobTickets[0].id : allJobTickets[resultIndex].id;
    return resultSelectedTicketId;
  };

  const selectedTicketId = handleSelectedTicket();

  const renderTab = (ticket) => {
    const { setTicketIdAction } = props;
    const { id, ticket_number: ticketNumber } = ticket;

    return (
      <NavItem
        key={id}
        eventKey={id}
        onClick={() => { return setTicketIdAction(id); }}
      >{ticketNumber.number}
      </NavItem>
    );
  };

  const renderTicketTabs = () => {
    if (!jobId) {
      return (<div />);
    }

    return (
      <Nav bsStyle="tabs" activeKey={selectedTicketId}>
        {allJobTickets.map(renderTab)}
      </Nav>
    );
  };

  const handlePdfDownload = () => {
    const { job } = props.allJobTickets[0];
    const { apiServerUrl } = props;
    const pdfUrl = linkWithCredentials(`${apiServerUrl}${job.pdf_path}`);
    downloadingFileAndUpdatingCredentials(pdfUrl);
  };

  const onUpdateJob = async (e) => {
    try {
      await dispatchUpdateJobAction(jobId, e.lease.user_id);
      setJobEditorModalError(null);
      closeJobEditorModal();
    } catch (error) {
      setJobEditorModalError(tryHandleGraphQLError(error));
    }
  };

  const { mutable, immutableReason } = currentJob;
  const incompletedJob = currentJob.state !== 'completed';
  const showReplaceButton = incompletedJob || replaceCompletedTickets;
  const canEdit = (mutable || updateImmutableTickets);

  return (
    <Grid fluid>
      {renderTicketTabs()}
      <div className="panel panel-default panel-tabbed">
        <DetailsProcessorEnhanced
          canEdit={canEdit && !viewer}
          canDeleteTickets={destroyTickets}
          showReplaceButton={showReplaceButton}
          isJobMutable={mutable}
          immutableReason={immutableReason}
          jobId={jobId}
          ticketId={selectedTicketId}
          viewer={viewer}
        />
        <div className="panel-footer">
          <Clearfix>
            <ButtonToolbar className="pull-left">
              <Button bsStyle="info" onClick={handlePdfDownload}>
                <Glyphicon glyph="export" style={{ marginRight: '0.5em' }} />
                Export Job as PDF
              </Button>
            </ButtonToolbar>
            <ButtonToolbar className="pull-right">
              <Button
                disabled={!canEdit || viewer}
                bsStyle="primary"
                onClick={openJobEditorModal}
              > Edit Job
              </Button>
            </ButtonToolbar>
          </Clearfix>
        </div>
      </div>
      <JobEditorModal
        jobId={jobId}
        onSubmit={onUpdateJob}
        jobEditorErrors={jobEditorErrors}
        showJobEditorModal={showJobEditorModal}
        closeJobEditorModal={closeJobEditorModal}
      />
    </Grid>
  );
};


const mapStateToProps = (state) => {
  return {
    apiServerUrl: getApiServerUrl(state),
    features: getUserFeatures(state),
  };
};

const mapDispatchToProps = {
  setTicketIdAction: setTicketId,
  dispatchUpdateJobAction: dispatchUpdateJob,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoJobTickets = branch(
  (props) => {
    return (props.allJobTickets.length === 0);
  },
  renderComponent((props) => {
    return (
      <div>
        Job Id ({props.jobId}) has no tickets assigned to it.
      </div>
    );
  }),
);

const enhance = compose(
  withRedux,
  queryAllJobTicketsGQL,
  withNoJobTickets,
  withModalState,
);

JobViewer.propTypes = propTypes;


export default enhance(JobViewer);
